(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lecce-afterpay-message"] && !Shopify.designMode) return;
  try {
    (() => {
    const updateShopPayFallback = () => {
      document.querySelectorAll('.lecce-shop-pay-message').forEach((container) => {
        const fallback = container.querySelector('[data-lecce-shop-pay-fallback]');
        const nativeTerms = container.querySelector('shopify-payment-terms');
        if (!fallback) return;

        const nativeVisible = nativeTerms && nativeTerms.getBoundingClientRect().height > 0;
        fallback.classList.toggle('is-visible', !nativeVisible);
      });
    };

    requestAnimationFrame(updateShopPayFallback);
    window.setTimeout(updateShopPayFallback, 800);
    document.addEventListener('shopify:section:load', updateShopPayFallback);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lecce-color-preview"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
  if (input.matches('.productitem--swatches-input[data-lecce-swatch-image]')) {
    const url = input.dataset.lecceSwatchImage;
    const card = input.closest('.productgrid--item');
    const figure = card?.querySelector('.productitem--image');
    if (!url || !figure) return;
    let image = figure.querySelector('.lecce-swatch-preview');
    if (!image) {
      image = document.createElement('img');
      image.className = 'productitem--image-primary lecce-swatch-preview';
      figure.appendChild(image);
    }
    image.alt = input.value;
    image.src = url;
    figure.dataset.lecceColorPreview = '';
  }
  if (input.matches('[data-lecce-swatch-media]') && input.dataset.lecceSwatchMedia) {
    const section = input.closest('.shopify-section');
    const button = section?.querySelector('button[data-media="' + input.dataset.lecceSwatchMedia + '"]');
    if (button) requestAnimationFrame(() => button.click());
  }
});

const lecceColorCache = new Map();
function leccePhotoColor(url) {
  if (lecceColorCache.has(url)) return lecceColorCache.get(url);
  const promise = new Promise((resolve, reject) => {
    const photo = new Image();
    photo.crossOrigin = 'anonymous';
    photo.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = 32; canvas.height = 32;
        const context = canvas.getContext('2d', { willReadFrequently: true });
        context.drawImage(photo, 0, 0, 32, 32);
        const pixels = context.getImageData(6, 6, 20, 20).data;
        const groups = new Map();
        for (let i = 0; i < pixels.length; i += 4) {
          if (pixels[i + 3] < 128) continue;
          const r = pixels[i], g = pixels[i + 1], b = pixels[i + 2];
          const key = [r, g, b].map(c => Math.floor(c / 24)).join(',');
          const group = groups.get(key) || { count: 0, r: 0, g: 0, b: 0 };
          group.count++; group.r += r; group.g += g; group.b += b;
          groups.set(key, group);
        }
        const dominant = [...groups.values()].sort((a, b) => b.count - a.count)[0];
        if (!dominant) throw new Error('No image pixels');
        resolve('rgb(' + [dominant.r, dominant.g, dominant.b].map(c => Math.round(c / dominant.count)).join(',') + ')');
      } catch (error) { reject(error); }
    };
    photo.onerror = reject;
    photo.src = url;
  });
  lecceColorCache.set(url, promise);
  return promise;
}
function lecceSolidColors(root = document) {
  root.querySelectorAll('.productitem--swatches-swatch-inner, .options-selection__option-swatch-inner, .lecce-single-swatch').forEach(swatch => {
    if (swatch.dataset.lecceColorSampled) return;
    const background = swatch.style.backgroundImage;
    const match = background.match(/^url\(["']?(.*?)["']?\)$/);
    if (!match) return;
    swatch.dataset.lecceColorSampled = 'pending';
    leccePhotoColor(match[1]).then(color => {
      swatch.style.setProperty('background-color', color, 'important');
      swatch.dataset.lecceColorSampled = color;
    }).catch(() => { swatch.dataset.lecceColorSampled = 'unavailable'; });
  });
}
lecceSolidColors();
document.addEventListener('DOMContentLoaded', () => lecceSolidColors());
document.addEventListener('shopify:section:load', () => lecceSolidColors());
let lecceColorQueued = false;
new MutationObserver(() => {
  if (lecceColorQueued) return;
  lecceColorQueued = true;
  requestAnimationFrame(() => { lecceColorQueued = false; lecceSolidColors(); });
}).observe(document.documentElement, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

})();
